import {all} from 'redux-saga/effects';
import {createFetchSagaLatest, createPostSagaLatest} from 'utils/sagas';

import {
  promoteToMember as promoteToMemberAction,
  createMember as createMemberAction,
  createUser as createUserAction,
  updateUser as updateUserAction,
  demoteMember as demoteMemberAction,
  verifyUserInternalAvatarUpload as verifyUserInternalAvatarUploadAction,
  fetchUsers as fetchUsersAction,
  fetchMembersForDashboard as fetchMembersForDashboardAction
} from './';

import {
  fetchUsers,
  verifyUserInternalAvatarUpload,
  promoteToMember,
  createMember,
  createUser,
  updateUser,
  demoteMember,
  fetchMembersForDashboard
} from 'sdk/users';

function* userListSaga() {
  yield all([
    createPostSagaLatest(promoteToMemberAction, promoteToMember),
    createPostSagaLatest(createMemberAction, createMember),
    createPostSagaLatest(createUserAction, createUser),
    createPostSagaLatest(updateUserAction, updateUser),
    createPostSagaLatest(demoteMemberAction, demoteMember),
    createPostSagaLatest(
      verifyUserInternalAvatarUploadAction,
      verifyUserInternalAvatarUpload
    ),
    createFetchSagaLatest(fetchUsersAction, fetchUsers),
    createFetchSagaLatest(
      fetchMembersForDashboardAction,
      fetchMembersForDashboard
    )
  ]);
}

export default userListSaga;
